module.exports = __webpack_public_path__ + "static/ArtemisBlue-f45a828df20cded7abae38df44c203ad.jpg";